import RequireSuperAdminMiddleware from 'middlewares/RequireSuperAdminMiddleware'

const middlewares = [RequireSuperAdminMiddleware]

export default [
    {
        path: '/governance',
        name: 'governance',
        redirect: { name: 'governance.overview' },
    },
    {
        path: '/governance/overview',
        name: 'governance.overview',
        view: 'governance/Overview',
        middlewares,
    },
    {
        path: '/governance/referral/:referralId',
        name: 'governance.detail',
        view: 'governance/BroadcastDetail',
        middlewares,
    },
]
